module.exports = __webpack_public_path__ + "static/media/junk-is-no-good-baby.d2d99885.jpg";